import { DocumentType } from "@/shared/types/documentTypes";

export interface KeyDocumentSlot {
  id: string;
  label: string;
  documentTypes: DocumentType[];
  notApplicableLabel?: string;
}

export const KEY_DOCUMENT_SLOTS: KeyDocumentSlot[] = [
  {
    id: "death_certificate",
    label: "Death Certificate",
    documentTypes: [DocumentType.DEATH_CERTIFICATE],
  },
  {
    id: "will",
    label: "Will",
    documentTypes: [DocumentType.WILL],
    notApplicableLabel: "No will",
  },
  {
    id: "trust",
    label: "Trust",
    documentTypes: [DocumentType.TRUST, DocumentType.CERTIFICATION_OF_TRUST],
    notApplicableLabel: "No trust",
  },
  {
    id: "photo_id",
    label: "Your photo ID",
    documentTypes: [DocumentType.IDENTIFICATION_CARD],
  },
  {
    id: "letters",
    label: "Letters of Authority",
    documentTypes: [DocumentType.LETTERS_TESTAMENTARY, DocumentType.LETTERS_ADMINISTRATION],
  },
  {
    id: "ein_confirmation",
    label: "EIN Confirmation",
    documentTypes: [DocumentType.EIN_CONFIRMATION],
  },
];

export const KEY_DOCUMENT_TYPES: DocumentType[] = KEY_DOCUMENT_SLOTS.flatMap(
  (slot) => slot.documentTypes,
);

export const KEY_DOCUMENT_TOTAL = KEY_DOCUMENT_SLOTS.length;
